export interface toolTipProps {
  title: string;
  content: string;
  classNames?: string;
}

export default function ToolTip({ title, content, classNames }: toolTipProps) {
  return (
    <div className="relative flex flex-col sm:items-center group ">
      <div className={classNames + " absolute bottom-1 flex sm:flex-col flex-row items-center hidden mb-6 group-hover:flex"}>
        <span className="tooltip-box shadow-lg">
          <h2>{title}</h2>
          <p className="sub-heading">{content}</p>
        </span>
        <div className="w-3 h-3 z-10 -mt-2 rotate-45 max-sm:hidden tooltip-pointer shadow-lg opacity-100"></div>
      </div>
      <div className="mt-1">
        <img
          src="assets/tooltip-icon.svg"
          alt="tooltip"
          width={15}
          height={15}
        />
      </div>
    </div>
  );
}